import { ApiError } from '@/api/unwrapApiResult'

export const GRANT_PERMISSION_MESSAGE =
  'You can only grant permissions assigned to your own account.'

export function mapGrantPermissionError(error: unknown): unknown {
  if (error instanceof ApiError && error.statusCode === 403) {
    return new Error(GRANT_PERMISSION_MESSAGE)
  }
  return error
}
